<template>
  <div>
    <PublicLayout>
      <header class="sub-header">
        <div class="container">
          <h1>{{ activity.title }}</h1>
        </div>
      </header>
      <!-- main-section -->
      <section class="main-section">
        <section class="m-sec">
          <div class="container">
            <article class="public-news-detail-article">
              <header>
                <img :src="activity.image" class="w-100" />
              </header>
              <h2 class="my-3">{{ activity.title }}</h2>
              <p>{{ activity.subtitle }}</p>
            </article>
          </div>
        </section>
        <section class="m-sec">
          <div class="container">
            <router-link class="text-success" to="/activity-list">
              <i class="fas fa-chevron-left"></i>
              回到活動訊息
            </router-link>
          </div>
        </section>
      </section>
      <!-- main-section -->
    </PublicLayout>
  </div>
</template>

<script>
import PublicLayout from "../../components/public/PublicLayout";
import db from "../../api/db";
export default {
  name: "PublicActivityDetailScreen",
  components: {
    PublicLayout,
  },
  data() {
    return {
      activity: {
        title: "",
        subtitle: "",
      },
    };
  },
  methods: {},
  mounted() {
    const vm = this;
    const activityId = vm.$route.params.activityId;
    db.doc(`activities/${activityId}`)
      .get()
      .then((doc) => {
        const activity = doc.data();
        activity.id = doc.id;
        vm.activity = activity;
      })
      .catch((err) => {
        console.log("err", err);
      });
  },
};
</script>